/**
 * Image Expand Gallery - Improved JS
 */
(function () {
  'use strict';

  const initGallery = (section) => {
    const items = section.querySelectorAll('.heg-item');
    if (!items.length) return;

    const setActive = (index) => {
      items.forEach((item, i) => {
        item.classList.toggle('heg-item--active', i === index);
      });
    };

    items.forEach((item, index) => {
      // 桌面端：鼠标悬停展开
      item.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 768) {
          setActive(index);
        }
      });

      // 移动端/全端：点击处理
      item.addEventListener('click', (e) => {
        const isExpanded = item.classList.contains('heg-item--active');
        
        if (!isExpanded) {
          // 如果未展开，阻止链接跳转，仅展开
          e.preventDefault();
          setActive(index);
        } 
        // 如果已展开，允许默认行为（即 a 标签的跳转）
      });
    });
  };

  // 初始化所有画廊
  const load = () => {
    document.querySelectorAll('[data-section-type="image-expand-gallery"]').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }

  // 支持 Shopify 主题编辑器实时预览
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('[data-section-type="image-expand-gallery"]');
      if (section) initGallery(section);
    });
  }
})();